import Section from '../../enums/Sections';
import * as types from '../actions/action-types';

const getInitialState = () => ({
  screenDimensions: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  checkoutProgressStep: 1,
  sections: window.start.sections || [Section.ADDRESS, Section.DELIVERY, Section.PAYMENT],
  desktopBanner: undefined,
  mobileBanner: undefined,
});

const uiReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case types.SET_SHOULD_JUMP_TO_APM_HEADING: {
      return {
        ...state,
        shouldJumpToApmHeading: action.shouldJumpToApmHeading,
      };
    }
    case types.SET_SCREEN_DIMENSIONS:
      return {
        ...state,
        screenDimensions: {
          width: action.width,
          height: action.height,
        },
      };
    case types.SET_CHECKOUT_PROGRESS_STEP:
      return {
        ...state,
        checkoutProgressStep: action.stepNumber,
      };
    case types.UPDATE_SECTION_ORDER:
      state.sections.push(state.sections.splice(state.sections.indexOf(Section.DELIVERY), 1)[0]);
      return {
        ...state,
        sections: [...state.sections],
      };
    case types.UPDATE_SUBSCRIPTION_SECTION_ORDER:
      // eslint-disable-next-line no-case-declarations
      const newSectionFormat = state.sections.filter(section => section !== Section.PAYMENT);
      newSectionFormat.unshift(Section.PAYMENT);
      return {
        ...state,
        sections: [...newSectionFormat],
      };
    case types.REVERT_SECTION_ORDER:
      state.sections.push(state.sections.splice(state.sections.indexOf(Section.PAYMENT), 1)[0]);
      return {
        ...state,
        sections: [...state.sections],
      };
    case types.SET_BANNER_BACKGROUND_DESKTOP:
      return {
        ...state,
        desktopBanner: action.desktopBanner,
      };
    case types.SET_BANNER_BACKGROUND_MOBILE:
      return {
        ...state,
        mobileBanner: action.mobileBanner,
      };
    default:
      return state;
  }
};

export default uiReducer;
